import { render, staticRenderFns } from "./RoleSelectionModal.vue?vue&type=template&id=4d3f3552&scoped=true&"
import script from "./RoleSelectionModal.vue?vue&type=script&lang=js&"
export * from "./RoleSelectionModal.vue?vue&type=script&lang=js&"
import style0 from "./RoleSelectionModal.vue?vue&type=style&index=0&id=4d3f3552&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3f3552",
  null
  
)

export default component.exports